// @flow

import React from 'react';
import {
    InputCaretIcon,
    IconTypes
} from 'common/components/core/icon/InputCaretIcon';
import { SizeEnum } from 'common/enums/UIEnums';
import { Loader } from 'common/components/core/loader/Loader';
import MlFontIcon from 'common/components/core/font_icon/MlFontIcon';
import coreIds from 'common/tests/core/coreIds.json';

type Props = {
    theme: Object,
    showErrorIcon?: boolean,
    error?: string,
    info?: string,
    isInputLoading?: boolean
};

const InputIconView = ({
    showErrorIcon,
    error,
    info,
    theme,
    isInputLoading
}: Props) => {
    if (showErrorIcon) {
        return <MlFontIcon className={theme.errorIcon} iconClass="alert" />;
    }
    if (error) {
        return (
            <InputCaretIcon
                theme={theme}
                iconType={IconTypes.Error}
                popOverContent={error}
                testId={coreIds.error.errorIcon}
            />
        );
    }
    if (info) {
        return (
            <InputCaretIcon
                theme={theme}
                iconType={IconTypes.Info}
                popOverContent={info}
            />
        );
    }
    if (isInputLoading) {
        return (
            <Loader
                theme={theme}
                active={isInputLoading}
                size={SizeEnum.Small}
            />
        );
    }
    return null;
};

export default InputIconView;
